import withInjection from '@piconetworks/with-injection'
import IconButton from 'common/components/IconButton'

import Loader from 'common/modules/loader'
import xFrame from 'common/xFrame'
import Lifecycle from 'common/modules/lifecycle'
import Internal from 'common/modules/internal'

const mapStateToProps = (state, props) => ({
    ...props,
    publisherName: Loader.selectors.publisherName(state),
    publisherIcon: Loader.selectors.publisherIcon(state),
    hasUserLoader: Loader.selectors.hasUserLoader(state),
    linkColor: Loader.selectors.linkColor(state),
    getEntryRoute: () => {
        const scopedLoader = state.loader.user || state.loader.guest

        if (!scopedLoader) {
            return null
        }

        return '/registration'
    },
    warnings: {
        userNotVerified: state.loader.user && !Loader.selectors.userVerified(state),
        userHasFailedPayment: Loader.selectors.currentPurchaseFailed(state),
    },
})

const mapDispatchToProps = (dispatch) => ({
    dispatch,
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { dispatch } = dispatchProps

    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        buttonClick: () => {
            if (stateProps.hasUserLoader) {
                xFrame.launcher.toggleMenu({
                    dispatch,
                    showMenu: !stateProps.showCloseIcon,
                })
            } else {
                const entryRoute = stateProps.getEntryRoute()

                xFrame.launcher.toggleMenu({
                    dispatch,
                    showMenu: false,
                })

                xFrame.launcher.openPromptAndHeader({
                    dispatch,
                    entryRoute,
                })
                dispatch(Internal.creators.sendMessage({
                    payload: {
                        target: 'pico_arbiter',
                        ...(Lifecycle.creators.launcherPrompt()),
                    },
                }))
            }
        },
    }
}

const InjectedIconButton = withInjection(IconButton, {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
})

export default InjectedIconButton
